import typeModel from '../typeManage/typeModel.vue';
import { typeResource } from './../typeManage/request';
import { editStructure, addStructure } from './request';
export default {
  components: {
    typeModel
  },
  data() {
    return {
      dataFrom: {},
      dialogVisible: false,
      typeShow: false,
      type: '',
      typeList: [],
      customerId: ''
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('部门名称')
        }],
        orgType: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请选择') + this.$t('组织类型')
        }]
      };
    }
  },
  methods: {
    init(data, type) {
      console.log(data, type);
      this.customerId = data.customerId;
      this.handleOk(data);
      if (type) {
        this.dataFrom = {
          customerId: data.customerId,
          structureId: data.id,
          orgType: undefined
        };
      } else {
        this.dataFrom = {
          customerId: data.customerId,
          structureId: data.id,
          orgType: data.orgType,
          parentId: data.parentId,
          principal: data.principal,
          name: data.name,
          mobile: data.mobile
        };
      }
      this.type = type;
      this.dialogVisible = true;
      // this.handleOk();
    },
    handleOk(val) {
      this.dataFrom.orgType = val.organizationId;
      typeResource({
        customerId: this.customerId
      }).then(res => {
        this.typeList = res;
      });
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = !this.type ? editStructure : addStructure;
          fun(this.dataFrom).then(() => {
            this.$message.success(this.$t('操作成功'));
            this.$emit('ok');
            this.$emit('cancel');
          });
        }
      });
    },
    addOrgType() {
      this.typeShow = true;
      this.$nextTick(() => {
        this.$refs.typeForm.init({
          customerId: this.customerId
        });
      });
    }
  }
};